import { ChevronDownMedium } from '@zoopla-eng/zds/icons';
import { Stack } from '@zoopla-eng/zds/stack';
import { fontGroups } from '@zoopla-eng/zds/themes';
import {
    iconContainerStyle,
    selectWrapperStyle,
    styledLabelStyle,
    styledSelectStyle
} from './Filters.styles.css';

const beds = ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

const bedsOptions = [
    { value: '0', text: 'Studio' },
    { value: '1', text: '1' },
    { value: '2', text: '2' },
    { value: '3', text: '3' },
    { value: '4', text: '4' },
    { value: '5', text: '5' },
    { value: '6', text: '6' },
    { value: '7', text: '7' },
    { value: '8', text: '8' },
    { value: '9', text: '9' },
    { value: '10', text: '10+' }
];

export type BedsMin = typeof beds[number];
export type BedsMax = typeof beds[number];

type BedroomsProps = {
    value: {
        bedsMin: BedsMin;
        bedsMax: BedsMax;
    };
    onChange: ({
        bedsMin,
        bedsMax
    }: {
        bedsMin: BedsMin;
        bedsMax: BedsMax;
    }) => void;
};

export const Bedrooms = ({ value, onChange }: BedroomsProps) => {
    const bedsMinOptions =
        value.bedsMax !== ''
            ? bedsOptions.slice(0, Number(value.bedsMax) + 1)
            : bedsOptions;

    const bedsMaxOptions =
        value.bedsMin !== ''
            ? bedsOptions.slice(Number(value.bedsMin))
            : bedsOptions;

    return (
        <Stack
            flexDirection="row"
            flexWrap="wrap"
            columnGap="S400"
            rowGap="S400"
        >
            <div className={selectWrapperStyle}>
                <label
                    className={`${styledLabelStyle} ${fontGroups.ladle}`}
                    htmlFor="beds_min"
                >
                    Min beds
                </label>
                <select
                    className={`${styledSelectStyle} ${fontGroups.ladle}`}
                    name="beds_min"
                    id="beds_min"
                    onChange={(e) => {
                        onChange({
                            ...value,
                            bedsMin: e.target.value
                        });
                    }}
                    value={value.bedsMin}
                >
                    <option value="">No min</option>
                    {bedsMinOptions.map((bedsMinOption, index) => {
                        return (
                            <option
                                value={bedsMinOption.value}
                                key={`beds_mins_${index}`}
                            >
                                {bedsMinOption.text}
                            </option>
                        );
                    })}
                </select>
                <div className={iconContainerStyle}>
                    <ChevronDownMedium />
                </div>
            </div>
            <div className={selectWrapperStyle}>
                <label
                    className={`${styledLabelStyle} ${fontGroups.ladle}`}
                    htmlFor="beds_max"
                >
                    Max beds
                </label>
                <select
                    className={`${styledSelectStyle} ${fontGroups.ladle}`}
                    id="beds_max"
                    name="beds_max"
                    onChange={(e) => {
                        onChange({
                            ...value,
                            bedsMax: e.target.value
                        });
                    }}
                    value={value.bedsMax}
                >
                    <option value="">No max</option>
                    {bedsMaxOptions.map((bedsMaxOption, index) => {
                        return (
                            <option
                                value={bedsMaxOption.value}
                                key={`beds_max_${index}`}
                            >
                                {bedsMaxOption.text}
                            </option>
                        );
                    })}
                </select>
                <div className={iconContainerStyle}>
                    <ChevronDownMedium />
                </div>
            </div>
        </Stack>
    );
};
